import React from "react";
import {observer} from "mobx-react";
import PropTypes from 'prop-types';
import {useErrors} from "@morningtrain/react-resources";

function FieldErrors({name = null}) {

    const errors = useErrors(name);

    if (name === null || !errors || !Array.isArray(errors) || (Array.isArray(errors) && errors.length === 0)) {
        return null;
    }

    return (<p className="field-error">{errors.join(', ')}</p>);
}

FieldErrors.propTypes = {
    name: PropTypes.string
}

export default observer(FieldErrors);
